import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { UIButton } from "@/components/ui";
import { SvgAttribute } from "@/shared/constants/constants";

type StatusVariant = "warning" | "success";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    UIButton,
  },
  props: {
    variant: {
      type: String as PropType<StatusVariant>,
      default: "warning",
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    tags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    actionLabel: {
      type: String,
      default: "",
    },
  },
  emits: {
    action: null,
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },
  },
});
